import { getSiblings, breakpoint } from '../../util/helpers';
import RangeTouch from '../../util/rangetouch';

export default {
  init() {
    const modals = document.querySelectorAll('.ms-nutritional-modal');

    if (!modals.length) {
      return;
    }

    this.startListener(modals);
  },
  startListener(modals) {
    modals.forEach(modal => {
      const selector = {
        scroller: '.ms-nutritional-modal__scroller',
        scrollerControl: '.ms-nutritional-modal__scroller-control',
        scrollerTrack: '.ms-nutritional-modal__scroller-track',
        table: '.ms-nutritional-modal__table',
        tableInner: '.ms-nutritional-modal__table-inner',
      }

      let offset;

      const setOffset = () => {
        if (breakpoint() === 'mobile') {
          return offset = 16 * 2;
        } else if (breakpoint() === 'tablet') {
          return offset = 33 * 2 - 40;
        } else if (breakpoint() === 'desktop') {
          return offset = 80;
        }
      }

      const handleScrollerDisplay = () => {
        const table = modal.querySelector(selector.table);
        const scrollerTrack = modal.querySelector(selector.scrollerTrack);
        const parent = table && table.parentElement;
        const trackLimit = parent && (table.offsetWidth - offset) - parent.offsetWidth;

        if (trackLimit <= -20) {
          scrollerTrack.classList.add('hidden');
        } else {
          scrollerTrack.classList.remove('hidden');
        }
      }

      const resetPosition = () => {
        const scrollerControl = modal.querySelector(selector.scrollerControl);
        const table = modal.querySelector(selector.table);

        if (scrollerControl) {
          scrollerControl.removeAttribute('style');
        }

        if (table) {
          table.removeAttribute('style');
        }
      }

      window.addEventListener('load', () => {
        setOffset();
        handleScrollerDisplay();
      });

      window.addEventListener('resize', () => {
        resetPosition();
        setOffset();
        handleScrollerDisplay();
      });

      const scrub = event => {
        const { target } = event;
        const { value, parentElement } = target;

        getSiblings(target).forEach(sibling => {
          const parent = sibling.parentElement;
          const trackLimit = parent.offsetWidth - sibling.offsetWidth;
          sibling.style.left = `${(trackLimit / 100) * value}px`;
        });

        getSiblings(parentElement).forEach(sibling => {
          if (sibling.classList.contains('ms-nutritional-modal__wrapper')) {
            const table = sibling.querySelector(selector.table);
            const parent = sibling.parentElement;
            const trackLimit = (table.offsetWidth) - parent.offsetWidth;
            const finalValue = (trackLimit / 100) * value + 10; // 45px allowance
            table.style.transform = `translateX(-${finalValue}px)`;
          }
        });
      };

      const range = new RangeTouch(modal.querySelector(selector.scroller));
      const scrollerTrack = modal.querySelector(selector.scrollerTrack);
      const tableInner = modal.querySelector(selector.tableInner);

      if (tableInner && parseInt(modal.offsetWidth) < parseInt(tableInner.offsetWidth)) {
        scrollerTrack.remove();
      }

      range.element.oninput = event => scrub(event);
    });
  },
};



// WEBPACK FOOTER //
// /private/var/www/Morton-Windsor/wp-content/themes/morton-salt/resources/assets/scripts/multisite/modules/nutritional-modal.js